import { render, staticRenderFns } from "./DefaultEdited.vue?vue&type=template&id=51f779be&"
import script from "./DefaultEdited.vue?vue&type=script&lang=js&"
export * from "./DefaultEdited.vue?vue&type=script&lang=js&"
import style0 from "./DefaultEdited.vue?vue&type=style&index=0&id=51f779be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports